/**
 * Clases de los botones de la Power App (`src/components/ui/button.tsx`, tamaño por defecto), para aplicarlas
 * a un enlace sin `Slot` de Radix ni `class-variance-authority`.
 */
const BASE =
  'inline-flex h-9 shrink-0 items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors outline-none disabled:pointer-events-none disabled:opacity-50 has-[>svg]:px-3 focus-visible:ring-[3px] focus-visible:ring-ring/40 [&_svg]:pointer-events-none [&_svg]:shrink-0';

const VARIANTS = {
  default: 'bg-primary text-primary-foreground hover:bg-primary/90',
  outline: 'border border-border bg-card text-foreground hover:bg-muted hover:text-foreground',
  ghost: 'hover:bg-muted hover:text-foreground',
} as const;

export function buttonClasses(variant: keyof typeof VARIANTS = 'default', className = ''): string {
  return `${BASE} ${VARIANTS[variant]} ${className}`;
}
